import { Stack } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { ProcessPaymentDialogButton } from '../../../../payment/components/forms/ProcessPayment/ProcessPaymentDialogButton';
import { useAllowedPaymentMethodsForInvoices } from './constants';

export const HeaderActions = ({ accountId }: { accountId: string }) => {
    const allowedPaymentTypes = useAllowedPaymentMethodsForInvoices();

    return (
        <Stack>
            <ProcessPaymentDialogButton
                accountId={accountId}
                allowedPaymentTypes={allowedPaymentTypes}
                splitButtonTextKeys={{
                    mainButton: TextKey.ProcessPaymentPanelTitleForInvoicesTable,
                    sideButton: TextKey.ProcessPaymentDialogSplitButtonListItemPrimaryText,
                }}
                canLinkInvoices
            />
        </Stack>
    );
};
